import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    MenuItem,
    CircularProgress,
} from "@mui/material";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { CssTextField, Dropdown } from "qubCommon/Inputs";
import { getSeasons } from "apis/controllers/settings";
import { useDispatch } from "react-redux";
import { changeSeason } from "store/authReducer";
import { useNavigate } from "react-router-dom";

const SeasonDialog = ({ open, onClose, currentSeason, onChange }) => {
    const seasonForm = useForm();
    const [seasons, setSeasons] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate();

    // Fetch available seasons
    useEffect(() => {
        const loadSeasons = async () => {
            setLoading(true);
            try {
                const res = await getSeasons();
                if (Array.isArray(res)) {
                    setSeasons(res);
                }
            } catch (err) {
                console.error("Failed to fetch seasons", err);
            } finally {
                setLoading(false);
            }
        };

        if (open) loadSeasons();
    }, [open]);

    // Preselect current season
    useEffect(() => {
        if (currentSeason) seasonForm.setValue("season", currentSeason);
    }, [currentSeason, seasonForm.setValue]);


    const onSubmit = (data) => {
        console.log(data)
        dispatch(changeSeason(data))
        navigate(0);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                },
            }}
        >
            <DialogTitle variant="h4" sx={{ fontWeight: 600, pb: 1.5 }}>
                Αλλαγή Έτους
            </DialogTitle>

            <DialogContent dividers sx={{ pt: 2, pb: 1 }}>
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                        <CircularProgress size={28} />
                    </Box>
                ) : (
                    <FormProvider {...seasonForm}>
                        <Dropdown
                            valueName='id'
                            labelName='description'
                            label='Επιλέξτε Έτος'
                            name='season'
                            options={seasons}
                        />
                    </FormProvider>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} variant="contained" color='error'>
                    Άκυρο
                </Button>
                <Button
                    variant="contained"
                    onClick={seasonForm.handleSubmit(onSubmit)}
                    disabled={loading}
                >
                    Αλλαγή
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SeasonDialog;
